import { type ReactNode } from "react"

import { Navigate, useLocation } from "react-router-dom"

import { useUserSession } from "@session/UserSession"

interface ProtectedRoutesProps {
    children: ReactNode
}
export function ProtectedRoutes({ children }: Readonly<ProtectedRoutesProps>) {
    const { user, isLoading } = useUserSession()
    const location = useLocation()

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-svh">
                <div className="flex flex-col gap-2 text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                    <p className="text-sm text-muted-foreground">Loading...</p>
                </div>
            </div>
        )
    }

    return user ? children : <Navigate to="/login" state={{ from: location }} replace />
}
